// MO4.1
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/16x16/ArrowDown';
import ArrowUpIcon from '@wix/da-ds/pkg/Icons/ArrowUp';
import Flex from '@wix/da-ds/pkg/Flex';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { hashString } from '../../../utils/hash';
import Dumbo from '../../Dumbo';
import TierStatisticsBar from '../../Helper/StatisticsBar/TierStatisticsBar';
import Benefits from '../Benefits';
import { formatPrice } from '../utils';
import s from './TierProductCardDumbDesktop.scss';
const coverWidth = parseInt(s['cover-width']);
const coverHeight = parseInt(s['cover-height']);
const TierProductCardDumbDesktop = ({ coverImage, showMatureCover, title, stats, dataHook, description, price = '', benefits = [], hasDiscord, info, ctaButton, withExpandButton, coverAreaExtrasLeft, coverAreaExtrasRight, isHighlighted, showEmptyPlaceholders, className, onClick, onToggleCollapsed, isCollapsed: isCollapsedProp, innerRef })=>{
    const { t } = useTranslation();
    const [isCollapsedState, setIsCollapsed] = useState(false);
    const isControlled = isCollapsedProp !== undefined;
    const isCollapsed = isControlled ? isCollapsedProp : isCollapsedState;
    const hasBenefits = benefits.length > 0 || hasDiscord;
    const benefitsHash = hashString(`benefits.${benefits.join('|')}`);
    const toggleCollapsed = useCallback(()=>{
        if (isControlled) {
            onToggleCollapsed && onToggleCollapsed(!isCollapsed);
        } else {
            setIsCollapsed(!isCollapsed);
        }
    }, [
        onToggleCollapsed,
        isControlled,
        isCollapsed
    ]);
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], 'ds-card', isHighlighted && 'ds-card-selected', onClick && s['clickable-root'], className),
        direction: "column",
        onClick: onClick,
        innerRef: innerRef,
        dataHook: dataHook
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['cover-container']
    }, coverAreaExtrasLeft && /*#__PURE__*/ React.createElement("div", {
        className: s['cover-area-extras-left']
    }, coverAreaExtrasLeft), coverAreaExtrasRight && /*#__PURE__*/ React.createElement("div", {
        className: s['cover-area-extras-right']
    }, coverAreaExtrasRight), coverImage ? /*#__PURE__*/ React.createElement(Dumbo, {
        width: coverWidth,
        height: coverHeight,
        className: s['cover'],
        deviation: coverImage,
        showMatureContent: showMatureCover
    }) : /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['cover'], s['placeholder-cover'])
    })), title && /*#__PURE__*/ React.createElement(Heading, {
        className: s['title']
    }, title), !title && showEmptyPlaceholders && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['placeholder'], s['placeholder-title'])
    }), /*#__PURE__*/ React.createElement(TierStatisticsBar, {
        className: s['stats'],
        stats: stats
    }), price && /*#__PURE__*/ React.createElement("div", {
        className: s['price-block']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, formatPrice(price)), /*#__PURE__*/ React.createElement("span", {
        className: s['price-period']
    }, "/", t('deviationview.tierCard.pricePeriod.month'))), !price && showEmptyPlaceholders && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['placeholder'], s['placeholder-price'])
    }), ctaButton && /*#__PURE__*/ React.createElement("div", {
        className: s['cta-button']
    }, ctaButton), description && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['description'], (!hasBenefits || isCollapsed) && s['no-benefits'])
    }, description), !description && showEmptyPlaceholders && /*#__PURE__*/ React.createElement("div", {
        className: s['placeholder-description']
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['placeholder'], s['placeholder-line'])
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['placeholder'], s['placeholder-line'])
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['placeholder'], s['placeholder-line'])
    })), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['collapsible'], isCollapsed && s['collapsed'])
    }, (hasBenefits || showEmptyPlaceholders) && /*#__PURE__*/ React.createElement(Benefits, {
        key: benefitsHash,
        benefits: benefits,
        showPlaceholder: showEmptyPlaceholders,
        hasDiscord: hasDiscord
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['footer']
    }, info && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("hr", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(Flex, {
        className: s['info-block'],
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        size: IconSize.SMALLER,
        className: s['info-icon'],
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, info))), withExpandButton && hasBenefits && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("hr", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        onClick: toggleCollapsed,
        className: s['toggle-button']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['toggle-button-label']
    }, isCollapsed ? t('deviationview.tierCard.showMore') : t('deviationview.tierCard.showLess')), isCollapsed ? /*#__PURE__*/ React.createElement(ArrowDownIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }) : /*#__PURE__*/ React.createElement(ArrowUpIcon, {
        size: IconSize.SMALLER,
        disableDefaultColors: true
    })))));
};
TierProductCardDumbDesktop.displayName = 'TierProductCardDumbDesktop';
export default TierProductCardDumbDesktop;
